if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,

        init() {
          // Restore
          this.checked = localStorage.cart_term_checked === 'agreed';

          // Keep Eurus behaviour
          this.$watch('checked', () => {
            this.save();
            this.syncCheckoutState();
          });

          // Theme validation hook (keep)
          document.addEventListener('eurus:cart:validate', () => {
            this.checked = localStorage.cart_term_checked === 'agreed';
            if (!this.checked) Alpine.store('xCartHelper').validated = false;
          });

          // Add hard blocking
          this.bindCheckoutGuards();

          // Initial visual state
          this.syncCheckoutState();
        },

        bindCheckoutGuards() {
          const isCartContext = () => this.$el && document.body.contains(this.$el);

          const blockAndFocus = () => {
            // Ensure the warning shows
            this.checked = false;

            this.$nextTick(() => {
              try {
                this.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } catch (e) {}
            });
          };

          // Capture submit on the cart form (covers pressing enter, standard checkout submit)
          document.addEventListener(
            'submit',
            (e) => {
              if (!isCartContext()) return;

              const form = e.target;
              if (!(form instanceof HTMLFormElement)) return;

              // Shopify cart forms post to /cart
              const action = (form.getAttribute('action') || '').toLowerCase();
              if (!action.includes('/cart')) return;

              // Only block when the submitter is checkout related
              const submitter = e.submitter;
              const isCheckoutSubmit =
                !submitter ||
                submitter.name === 'checkout' ||
                submitter.getAttribute?.('data-checkout') !== null;

              if (isCheckoutSubmit && !this.checked) {
                e.preventDefault();
                e.stopImmediatePropagation();
                blockAndFocus();
              }
            },
            true
          );

          // Capture click on any checkout trigger (covers theme JS that redirects to /checkout)
          document.addEventListener(
            'click',
            (e) => {
              if (!isCartContext()) return;

              const trigger = e.target.closest(
                'button[name="checkout"], input[name="checkout"], [data-checkout], a[href^="/checkout"]'
              );
              if (!trigger) return;

              if (!this.checked) {
                e.preventDefault();
                e.stopImmediatePropagation();
                blockAndFocus();
              }
            },
            true
          );
        },

        syncCheckoutState() {
          // Visually disable checkout buttons when unticked (optional but recommended)
          const disabled = !this.checked;

          const buttons = document.querySelectorAll(
            'button[name="checkout"], input[name="checkout"], [data-checkout]'
          );

          buttons.forEach((btn) => {
            // inputs + buttons can be disabled
            btn.disabled = disabled;
            btn.classList.toggle('opacity-50', disabled);
            btn.classList.toggle('cursor-not-allowed', disabled);
          });
        },

        save() {
          clearTimeout(this.t);

          const func = () => {
            const status = this.checked ? 'agreed' : 'not agreed';
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': status,
              },
            });
            localStorage.cart_term_checked = status;
          };

          this.t = setTimeout(() => {
            func();
          }, 200);
        },
      }));
    });
  });
}
